import { render, staticRenderFns } from "./theoryManage.vue?vue&type=template&id=60b50caa&scoped=true"
import script from "./theoryManage.vue?vue&type=script&lang=js"
export * from "./theoryManage.vue?vue&type=script&lang=js"
import style0 from "./theoryManage.vue?vue&type=style&index=0&id=60b50caa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b50caa",
  null
  
)

export default component.exports